import { deleteGisLayer, getAllGisLayers } from "services/requests/v1/gislayer";

import {
    GisLayerTableType,
    SetRequestError,
    SubscribeContentType,
    UnsubscribeContentType,
} from "types/generic";

import ModalContentLayout from "./modal-content-layout.component";
import { useTranslation } from "utils/hooks/use-translation.hook";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
import NestedList from "./nested-list.component";

interface ConfirmationDeleteType {
    layerId: number;
    layerName: string;
    closeModal: () => void;
    setRowData: (rowSelected: GisLayerTableType[]) => void;
    subscribeContent: SubscribeContentType;
    unsubscribeContent: UnsubscribeContentType;
    setError: SetRequestError;
}

const ConfirmationDeleteModal = ({
    layerId,
    layerName,
    closeModal,
    setRowData,
    setError,
    subscribeContent,
    unsubscribeContent,
}: ConfirmationDeleteType) => {
    const translate = useTranslation();

    const handleDeleteClick = async () => {
        const contentName = "delete-layer";
        subscribeContent(contentName);

        try {
            await deleteGisLayer(layerId);
            getAllGisLayers().then((res) => {
                setRowData(res.data);
                unsubscribeContent(contentName, true);
            });
            closeModal();
        } catch (error) {
            setError(contentName);
        }
    };

    return (
        <ModalContentLayout
            firstButtonStatus="enabled"
            secondButtonStatus="enabled"
            onFirstButtonClick={closeModal}
            onSecondButtonClick={handleDeleteClick}
            firstButtonTitle={translate("app.gis.cancel")}
            secondButtonTitle={translate("app.Components.warning.delete")}
        >
            <div className="c-confirmation-modal">
                <FontAwesomeIcon
                    className="c-confirmation-modal__icon"
                    icon={faExclamationTriangle}
                />
                <div className="c-confirmation-modal__message-container">
                    <span className="c-confirmation-modal__message">
                        {translate("app.gis.detete_confirmation")}
                    </span>

                    <div className="c-confirmation-modal__list ">
                        <NestedList
                            data={[{ key: layerId, label: layerName }]}
                        />
                    </div>
                </div>
            </div>
        </ModalContentLayout>
    );
};

export default ConfirmationDeleteModal;
